// Log levels
const LogLevel = {
  DEBUG: 'DEBUG',
  INFO: 'INFO',
  WARN: 'WARN',
  ERROR: 'ERROR'
};

// Colors for different log levels
const colors = {
  DEBUG: '#7f8c8d',
  INFO: '#2ecc71',
  WARN: '#f1c40f',
  ERROR: '#e74c3c'
};

// Format timestamp
const getTimestamp = () => {
  return new Date().toISOString();
};

// Format log message
const formatMessage = (level, message, data = null) => {
  const timestamp = getTimestamp();
  const style = `color: ${colors[level]}; font-weight: bold;`;
  
  if (data) {
    console.log(`%c[${timestamp}] ${level}:`, style, message, data);
  } else {
    console.log(`%c[${timestamp}] ${level}:`, style, message);
  }
};

// Logger class
class Logger {
  static debug(message, data = null) {
    if (process.env.NODE_ENV === 'development') {
      formatMessage(LogLevel.DEBUG, message, data);
    }
  }

  static info(message, data = null) {
    formatMessage(LogLevel.INFO, message, data);
  }

  static warn(message, data = null) {
    formatMessage(LogLevel.WARN, message, data);
  }

  static error(message, error = null) {
    formatMessage(LogLevel.ERROR, message, error);
  }

  // Log API errors with additional context
  static apiError(endpoint, error) {
    const errorMessage = error.response?.data?.error || error.message || 'Unknown error';
    this.error(`API Error (${endpoint}):`, {
      status: error.response?.status,
      message: errorMessage,
      details: error.response?.data
    });
  }

  // Log state changes
  static stateChange(component, action, data = null) {
    this.debug(`State Change [${component}] - ${action}`, data);
  }

  // Log user actions
  static userAction(action, details = null) {
    this.info(`User Action: ${action}`, details);
  }
}

export default Logger; 